// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file event/v1/checkout_trace_event.proto (package event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Timestamp } from "../../google/protobuf/timestamp_pb";

/**
 * @generated from enum event.v1.CheckoutTraceType
 */
export const CheckoutTraceType = proto3.makeEnum(
  "event.v1.CheckoutTraceType",
  [
    {no: 0, name: "CHECKOUT_TRACE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CHECKOUT_TRACE_TYPE_REQUEST", localName: "REQUEST"},
    {no: 2, name: "CHECKOUT_TRACE_TYPE_RESPONSE", localName: "RESPONSE"},
    {no: 3, name: "CHECKOUT_TRACE_TYPE_ERROR", localName: "ERROR"},
  ],
);

/**
 * @generated from enum event.v1.RequestType
 */
export const RequestType = proto3.makeEnum(
  "event.v1.RequestType",
  [
    {no: 0, name: "REQUEST_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "REQUEST_TYPE_PAY", localName: "PAY"},
    {no: 3, name: "REQUEST_TYPE_SETUP_CHECKOUT_INTENT", localName: "SETUP_CHECKOUT_INTENT"},
    {no: 4, name: "REQUEST_TYPE_GET_MERCHANT_SETTINGS", localName: "GET_MERCHANT_SETTINGS"},
    {no: 5, name: "REQUEST_TYPE_GET_CHECKOUT_SESSION", localName: "GET_CHECKOUT_SESSION"},
  ],
);

/**
 * @generated from message event.v1.CheckoutTraceEventPayload
 */
export const CheckoutTraceEventPayload = proto3.makeMessageType(
  "event.v1.CheckoutTraceEventPayload",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "merchant_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "payload", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "request_type", kind: "enum", T: proto3.getEnumType(RequestType) },
    { no: 7, name: "checkout_trace_type", kind: "enum", T: proto3.getEnumType(CheckoutTraceType) },
    { no: 8, name: "timestamp", kind: "message", T: Timestamp },
    { no: 9, name: "trace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "span_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

